import { createContext } from 'react'

import { MallLayoutContextValue } from './interface'

export const MallLayoutContext = createContext<
  MallLayoutContextValue | undefined
>(undefined)
